import type { ConditionConfigure } from '@lighthouse/shared'
import { FlowControlNodeType } from '@lighthouse/shared'

import type { ConditionValidator, NodeValidator } from '../types'

/**
 * condition validate
 */
const conditionValidator: NodeValidator<ConditionValidator<ConditionConfigure>, FlowControlNodeType.CONDITION> = {
    nodeType: FlowControlNodeType.CONDITION,
    validators: [
        node => {
            return !!node.data.config?.filterGroup && !!node.data.config?.filterGroup.length
        }
    ]
}

export const conditionValidators = [conditionValidator]
